import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ClipboardList, Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../../lib/api";

export const RecipeDraftsBar = ({ onDone }) => {
  const [job, setJob] = useState(null);
  const timer = useRef(null);

  const poll = () => api.get("/admin/kitchen/recipe-drafts").then((r) => {
    setJob(r.data);
    if (r.data.status === "running") timer.current = setTimeout(poll, 3000);
    else if (r.data.status === "done" && timer.current) { toast.success(`Drafted ${r.data.drafted} items from descriptions`); onDone(); }
    else if (r.data.status === "failed") toast.error("Drafting stopped early — try again.");
  });
  useEffect(() => { poll(); return () => clearTimeout(timer.current); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const start = async () => {
    try {
      const r = await api.post("/admin/kitchen/recipe-drafts");
      if (!r.data.total) { toast("Every item already has a recipe or checklist."); return; }
      setJob({ status: "running", total: r.data.total, processed: 0 });
      timer.current = setTimeout(poll, 3000);
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail) || "Couldn't start drafting.");
    }
  };
  const running = job?.status === "running";
  const btn = "inline-flex items-center gap-1.5 rounded-full px-4 h-10 text-[11px] font-bold uppercase tracking-[0.1em]";
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="recipe-drafts-bar">
      <button type="button" onClick={start} disabled={running} data-testid="recipe-drafts-start" className={`${btn} bg-brand-teal text-white disabled:opacity-60`}>
        {running ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Sparkles className="h-3.5 w-3.5" />}
        {running ? `Drafting ${job.processed}/${job.total}…` : "Fill in from descriptions"}
      </button>
      <Link to="/admin/kitchen/worksheet" target="_blank" data-testid="recipe-worksheet-link" className={`${btn} bg-white border border-brand-charcoal/15 text-brand-charcoal`}>
        <ClipboardList className="h-3.5 w-3.5" /> Print missing-info worksheet
      </Link>
    </div>
  );
};

export default RecipeDraftsBar;
